import {
  normalizeTimezoneIdentifier,
  serializeTimezoneForApi,
} from '@utils/timezone';
import {MemberSignupFormData} from './member-signup-interface';

type MemberAccountReadiness = Pick<
  MemberSignupFormData,
  | 'firstName'
  | 'lastName'
  | 'jobTitle'
  | 'password'
  | 'phoneNumber'
  | 'timezone'
> & {
  isPasswordValid: boolean;
};

export const canCreateMemberAccount = ({
  firstName,
  lastName,
  jobTitle,
  password,
  phoneNumber,
  timezone,
  isPasswordValid,
}: MemberAccountReadiness) =>
  Boolean(
    firstName &&
      lastName &&
      jobTitle &&
      password &&
      timezone &&
      isPasswordValid &&
      phoneNumber.length > 8,
  );

export const buildMemberSignupPayload = (
  data: MemberSignupFormData,
): MemberSignupFormData => ({
  ...data,
  customTimezone: true,
  timezone: serializeTimezoneForApi(normalizeTimezoneIdentifier(data.timezone)),
});
